import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import useUsersList from "../../hooks/useUsersList";
import TextInput from "../TextInput";
import User from "./User";
const Users = () => {
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");

  const { loading, users, error, hasMore, setUsers, fetchUsers } =
    useUsersList();
  const changeValue = (e) => {
    const text = e.target.value;
    setSearchText(text);
    if (text.length > 3) {
      const newUser = users.filter((user) => {
        if (
          user?.name.toLowerCase().search(text.toLowerCase()) === 0 ||
          user?.myReferCode.search(text) === 0
        ) {
          return user;
        }
      });
      if (newUser.length > 0) {
        setUsers(newUser);
      } else {
        fetchUsers();
      }
    } else {
      fetchUsers();
    }
  };

  return (
    <>
      <TextInput
        onChange={(e) => changeValue(e)}
        value={searchText}
        type="text"
        required
        placeholder="Search User"
        icon="search"
      />
      <br />
      <hr />
      <br />
      {users.length > 0 && (
        <Grid container spacing={5}>
          {users?.map((user) => (
            <Grid item xs={12} sm={6} md={4}>
              <User fetchUsers={fetchUsers} user={user} />
            </Grid>
          ))}
        </Grid>
      )}
      {!loading && users.length === 0 && <div>No Data Found!</div>}
      {error && <div>There was an error !</div>}
      {loading && <div>Loading...</div>}
    </>
  );
};

export default Users;
